export default {
  bill : {
    availableCredit:'账户余额',
    addFunds:'充值',
    month:'本月累计消费',
    history:'收支明细',
    order:'订单',
    startDate:'开始时间',
    endDate:'结束时间',
    search:'搜索',
    searchNumber:'输入交易订单号',
    download:'下载',
    historyList:{
      number:'流水号',
      tNumber:'交易订单号',
      date:'交易时间',
      type:'交易类型',
      TChannel:'支付渠道',
      amount:'金额',
      balance:'余额',
    },
    orderList:{
      tNnmber:'交易订单',
      zone:'地区',
      oType:'订单类型',
      pType:'产品类型',
      charge:'价格(￥/月)',
      status:'状态',
      time:'下单/支付时间',
      actions:'操作',
      view:'详情',
      pay:'支付',
    },
    pay:{
      title:'订单支付',
      detail:'详情',
      tNumber:'订单号: ',
      zone:'地区: ',
      pType:'产品类型:',
      oType:'订单类型: ',
      time:'下单时间:',
      price:'价格:',
      cancel:'取消',
      pay:'支付',
    },
    view:{
      title:'订单详情',
      detail:'订单汇总',
      tNumber:'订单号',
      oType:'订单类型: ',
      otime:'下单时间:',
      ptime:'支付时间:',
      odetail:'订单详情',
      product:'产品',
      num:'数量',
      config:'配置',
      price:'价格',
      pamount:'支付金额',
    },
    recharge:{
      title:'充值',
      pa:'金额:',
      pm:'支付方式:',
      cancel:'取消',
      pay:'支付',
    },
    paying:{
      title:'消息',
      desc:'请在新打开的页面进行付款。',
      after:'付款完成后，请根据您的情况，点击下面的按钮。',
      success:'支付成功',
      failed:'支付失败',
    }
  },
  user :{
    myProfiletitle:'我的资料',
    billingTitle:'账单',
    operationLogTitle:'操作记录',
    profile:'用户资料',
    log:'操作记录',
    detail:'您的详细信息',
    name:'昵称:',
    cname:'修改昵称',
    newName:'新的昵称:',
    confirm:'确认',
    curPwd:'原密码:',
    cPwd:'修改密码',
    curPwdDesc:'请在此输入原密码',
    newPwd:'新密码:',
    newPwdDescFirst:'请在此输入新密码',
    newPwdDescTwo:'请在此再次输入新密码',
    email:'邮箱:',
    cemail:'修改邮箱',
    nemail:'新邮箱:',
    phone:'手机:',
    cPhone:'修改手机',
    nPhone:'新手机:',
    send:'发送',
    reSend:'重新发送',
    code:'验证码',
    error:{
      phone:'请输入手机号',
      phoneFormat:'手机格式错误',
      emailAddress:'请输入邮箱地址',
      emailFormat:'邮箱格式错误',
      nickname:'请输入新的昵称',
      nicknameForamt:'昵称格式错误',
      password:'请输入新的密码',
      passwordFormat:'密码格式错误',
      passwordTwo:'请再次输入新的密码',
    },
    logList:{
      'obj':'操作对象',
      'LType':'操作类型',
      'LTypelist':[
        { text: '产品', value: 'product' },
        { text: '账号', value: 'account' },
        { text: '订单', value: 'order' },
        { text: '其他', value: 'other' },
      ],
      'pname':'产品名',
      'oname':'操作名',
      'otime':'操作时间',
    },
    cUs:'联系我们',
    ask:'单击此处询问您的问题或告诉我们您的建议',
    feed:{
      title:'反馈',
      type:'反馈类型:',
      fTitle:'标题:',
      desc:'描述:',
      email:'邮箱:',
      cancel:'取消',
      submit:'提交',
      typeList:{
        ecc:'云服务器',
        bms:'裸金属',
        mysql:'Mysql',
        disk:'磁盘',
        elb:'负载均衡',
        ip:'Ip',
        ssl:'证书',
      },
    }
  },

  }



// WEBPACK FOOTER //
// ./src/lang/zh-CN/user.js